import { map } from 'lodash-es'

const setUser = (_root, { user }, { cache }) => {
  const roles = map(user.roles, role => ({ ...role, __typename: 'Role' }))
  cache.writeData({ data: { user: { ...user, roles, __typename: 'User' } } })
  return null
}

export default setUser
